import React from 'react';
import KeywordHTML from './KeywordHTML';

interface HighlightableTextProps {
  html: string;
  className?: string;
  highlightingEnabled?: boolean;
}

const HighlightableText: React.FC<HighlightableTextProps> = ({
  html,
  className = '',
  highlightingEnabled = true
}) => {
  return (
    <KeywordHTML 
      html={html}
      className={`prose prose-lg max-w-none ${className}`}
      highlightingEnabled={highlightingEnabled}
    />
  );
};

export default HighlightableText;